import { render, staticRenderFns } from "./Orgs.vue?vue&type=template&id=49f9d14c&"
import script from "./Orgs.vue?vue&type=script&lang=js&"
export * from "./Orgs.vue?vue&type=script&lang=js&"
import style0 from "./Orgs.vue?vue&type=style&index=0&id=49f9d14c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports